module.exports = __webpack_public_path__ + "static/media/chicken5.aceed31f.jpg";